import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  IconButton, 
  Typography 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const BaseModal = ({ 
  open, 
  handleClose, 
  title, 
  children, // This is where your components go
  actions  // Optional: for custom buttons at the bottom
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
//      fullWidth 
    //   maxWidth = "100%"   
          PaperProps={{
      sx:{
        width:'350px',
        maxWidth:'100$'
      }
    }}
    //   sx={{width:'450px'}}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" component="div">{title}</Typography>
        {handleClose ? (
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>

      <DialogContent dividers>
        {/* Any elements passed between the tags will appear here */}
        {children}
      </DialogContent>

      {actions && (
        <DialogActions>
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default BaseModal;